import "pickadate/lib/picker.js";
import "pickadate/lib/picker.date.js";
import "pickadate/lib/picker.time.js";
import "pickadate/lib/translations/fr_FR.js";
//import formSelect from '../modules/form';

import * as FormValidation from 'formvalidation';
import Bootstrap from 'formvalidation/dist/es6/plugins/Bootstrap';

$(document).ready(function () {
    //formSelect();

    $('.rdv-datepicker').pickadate({
        selectYears: false,
        min: '+3 days',
        disable: [new Date(), 7],
        format: 'dd/mm/yyyy',
        formatSubmit: 'yyyy-mm-dd'
    });

    $('#rdv-hour .rdv-hour').on('click', function(e) {
        e.preventDefault();

        if ($(this).hasClass('active')) {
            $('#rdv-hour .rdv-hour').removeClass('active');
            var HourData = '';
        } else {
            $('#rdv-hour .rdv-hour').removeClass('active');
            $(this).addClass('active');
            var HourData = $(this).data('hour');
        }

        $('#rdv-hour input[type=hidden]').val(HourData);
    });

    /* FORM VALIDATION */
    const form = document.getElementById('form-test-drive');
    if (form !== null) {
        FormValidation.formValidation(form, {
            fields: {
                'test_drive[lead][gender]': {
                    validators: {
                        notEmpty: {
                            message: "La civilité est obligatoire."
                        },
                    }
                },
                'test_drive[lead][lastname]': {
                    validators: {
                        notEmpty: {
                            message: "Le nom est obligatoire."
                        },
                        stringLength: {
                            max: 80,
                            message: 'Maximum de 80 caractères.'
                        },
                    }
                },
                'test_drive[lead][firstname]': {
                    validators: {
                        notEmpty: {
                            message: "Le prénom est obligatoire."
                        },
                        stringLength: {
                            max: 80,
                            message: 'Maximum de 80 caractères.'
                        },
                    }
                },
                'test_drive[lead][phone]': {
                    validators: {
                        notEmpty: {
                            message: "Le téléphone est obligatoire."
                        },
                        stringLength: {
                            max: 10,
                            min: 10,
                            message: 'Le téléphone doit contenir 10 caractères.'
                        },
                    }
                },
                'test_drive[lead][email]': {
                    validators: {
                        notEmpty: {
                            message: "L'adresse email est obligatoire."
                        },
                        emailAddress: {
                            message: "N'est pas une adresse mail valide."
                        }
                    }
                },
                'test_drive[lead][zipcode]': {
                    validators: {
                        notEmpty: {
                            message: "Le code postal est obligatoire."
                        }
                    }
                },
                'test_drive[lead][city]': {
                    validators: {
                        notEmpty: {
                            message: "La ville est obligatoire."
                        }
                    }
                },
            },
            plugins: {
                trigger: new FormValidation.plugins.Trigger(),
                bootstrap: new Bootstrap(),
                submitButton: new FormValidation.plugins.SubmitButton(),
                defaultSubmit: new FormValidation.plugins.DefaultSubmit(),
                /*icon: new FormValidation.plugins.Icon({
                    valid: 'fa fa-check',
                    invalid: 'fa fa-times',
                    validating: 'fa fa-refresh'
                }),*/ //Avec Bootstrap 4, ne pas oublier d'importer une fontIcons
                // declarative
                declarative: new FormValidation.plugins.Declarative({html5Input: true})
            }
        });
    }

    /*
    $('#form-rdv input').on('change', function(e) {
        $('#form-rdv').submit();
    });
    */

    // $('#date_and_time_desiredDate').pickadate({
    //     selectYears: false,
    //     /*klass: {
    //         picker: "picker picker--opened",
    //         opened: "__always-open__"
    //     },*/
    //     min: +2,
    //     disable: [6,7],
    //     onClose: function() {
    //         $('form[name=date_and_time]').formValidation('revalidateField', 'date_and_time[desiredDate]');
    //     },
    //     firstDay: 1,
    //     format: 'dd mmmm yyyy',
    //     formatSubmit: 'yyyy-mm-dd'
    // });
    //
    // $('#date_and_time_desiredTime').pickatime({
    //     format: 'H:i',
    //     interval: 30,
    //     min: [8,0],
    //     max: [18,0],
    //     /*klass: {
    //         picker: "picker picker--opened",
    //         opened: "__always-open__"
    //     },*/
    //     onClose: function() {
    //         $('form[name=date_and_time]').formValidation('revalidateField', 'date_and_time[desiredTime]');
    //     },
    //     clear: 'Effacer'
    // }).pickatime('picker');
    //
    // $('#vehicle_registrationDate').pickadate({
    //     selectYears: true,
    //     max: 'today',
    //     onClose: function() {
    //         $('form[name=vehicle]').formValidation('revalidateField', 'vehicle[registrationDate]');
    //     },
    //     firstDay: 1,
    //     format: 'dd mmmm yyyy',
    //     formatSubmit: 'yyyy-mm-dd'
    // });
});



// WEBPACK FOOTER //
// ./app/Resources/assets/default/js/vehicle/test-drive.js